// extracted by mini-css-extract-plugin
export default {"root":"WqyY2Wv8niuakAIOfU3L","current":"kBjd7QpXKUPEFeISjJw6","title":"IYih1bJxZ8YskcXYWpQU","year":"kzQ90JKzYWSihpHwklXg","placeHolderShimmer":"LNqAgcTC5rO4CxHkR_m7"};